var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-items-center shipment-item-header-expiration",class:{
    'shipment-item-header-expiration--expiring tw-text-red-500': _vm.isExpiring
  }},[_c('ui-ctk-icon',{staticClass:"tw-my-auto tw-mx-0",attrs:{"name":"expiration"}}),_c('span',{staticClass:"tw-hidden 2sm:tw-inline-block tw-my-auto tw-mx-0",domProps:{"textContent":_vm._s(_vm.$t('app.values.expires_at', {
      date: _vm.expiresAt
    }))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }